<template>
    <div class="page-side-panel contact-info-editor-pane"
         v-if="pageCopy">
        <div class="header-actions">
            <span class="title">Page Details</span>
            <div class="actions">            
                <button class="icomoon" @click="closePage">
                    
                </button>
            </div>
        </div>
        
        <div class="page-side-panel-content"
             v-if="pageCopy">

            <div class="form-control">
                <label>
                    Page Title
                </label>
                <input v-model="pageCopy.Name"
                       required
                       aria-label="Page Title">

            </div>

            <div class="form-control">
                <label>
                    Headline
                </label>
                <input v-model="pageCopy.Headlines"
                       required
                       aria-label="Headline">

            </div>

            <div class="form-control">
                <label><input type="checkbox" v-model="pageCopy.PublicWebEnabled"> Enable Public Page</label>
                <label v-if="pageCopy.PublicWebEnabled"><input type="checkbox" v-model="showPublicNavbar"> Show navbar</label>
                <div v-if="pageCopy.PublicWebEnabled && publicPageUrl" class="button-group">
                    <button type="button" @click="copyPublicPageLink">Copy Public Link</button>
                    <a :href="publicPageUrl" target="_blank" rel="noopener">Preview Public Page</a>
                </div>
            </div>
            <div class="form-control" v-if="pageCopy.PublicWebEnabled">
                <label for="pageGalleryTheme">Gallery theme</label>
                <select id="pageGalleryTheme" v-model="pageCopy.PublicWebLightMode">
                    <option :value="false">Dark</option>
                    <option :value="true">Light</option>
                </select>
            </div>
            <div class="form-control">
                <label><input type="checkbox" v-model="pageCopy.CaptureGateEnabled"> Require Viewer Details</label>
                <p v-if="pageCopy.CaptureGateEnabled">
                    Use Login Header and Login Footer elements to configure the capture form.
                    Custom fields in Login Footer are saved with each Page Logins entry. Give each field a unique
                    <code>id</code> or <code>name</code>; use <code>data-name</code> for its report label.
                </p>
            </div>
            <div class="form-control">
                <label><input type="checkbox" v-model="pageCopy.HasPageAccessPassword"> Require Page Password</label>
                <input v-if="pageCopy.HasPageAccessPassword" v-model="pageAccessPassword" type="password"
                       autocomplete="new-password" aria-label="Page password" placeholder="Page password">
                <p v-if="pageCopy.HasPageAccessPassword && hadPageAccessPassword">Leave blank to keep the current password.</p>
                <p v-else-if="hadPageAccessPassword">Saving will clear the current password.</p>
            </div>

            <div class="form-control">
                <label>
                    Cover YouTube/Vimeo/Embed URL
                </label>

                <input v-model="coverSourceUrl"
                       required
                       aria-label="YouTube/Vimeo/Embed URL">


            </div>


            <div class="form-control">
                <label>
                    Description/Bio
                </label>

                <textarea v-model="pageCopy.ContactInfo.Bio"
                          required
                          aria-label="Description/Bio"
                          rows="12">
                </textarea>

            </div>
        </div>
    </div>
</template>
<script>
import Common from './common'
import Token from './authentication/token'
import { AppState } from './appstate';;
import moment from 'moment'

export default {

    mixins: [
        Token,
        Common
    ],   

    props: ['attendee', 'sidebarParams'],

    computed: {
        showPublicNavbar: {
            get() { return !this.pageCopy.HidePublicNavbar; },
            set(value) { this.pageCopy.HidePublicNavbar = !value; }
        },
        publicPageUrl() {
            if(!AppState.show.Code || !this.pageCopy.Code) {
                return '';
            }
            return `${process.env.VUE_APP_WEBINAR_APP_URL}/g/${encodeURIComponent(AppState.show.Code)}/${encodeURIComponent(this.pageCopy.Code)}`;
        },
        coverSourceUrl: {
            get() {
                return this.pageCopy.PrimaryMedia.Uri;
            },
            set(value) {
                let finalUri = value;
                if(finalUri) {
                    let finalUriCheck = finalUri.toLowerCase();

                    this.pageCopy.PrimaryMedia.MediaType = 'LiveWebSource';

                    if(finalUriCheck.indexOf("https://") == -1
                        && finalUriCheck.indexOf("http://") == -1) {

                        finalUri = "https://" + finalUri;
                    }

                    finalUri = finalUri.replace('http://', 'https://');

                    if(finalUri.startsWith("https://www.youtube.com/watch?")
                        || finalUri.startsWith("https://youtu.be/")) {

                        finalUri = finalUri.replace('https://youtu.be/', 'https://www.youtube.com/watch?v=');

                        finalUri = finalUri.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/');
                    } else if (finalUri.startsWith("https://vimeo.com")) {

                        finalUri = finalUri.replace("https://vimeo.com/", 'https://player.vimeo.com/video/');
                    }

                } else {
                    this.pageCopy.PrimaryMedia.MediaType = null;
                }

                this.pageCopy.PrimaryMedia.Uri = finalUri;
            },
        },
    },

    watch: {
        'sidebarParams.Page': {
            immediate: true, 
            handler() {
                this.pageCopy = JSON.parse(JSON.stringify(this.sidebarParams.Page));
                this.pageCopy.PublicWebEnabled = !!this.pageCopy.PublicWebEnabled;
                this.pageCopy.PublicWebLightMode = !!this.pageCopy.PublicWebLightMode;
                this.pageCopy.HidePublicNavbar = !!this.pageCopy.HidePublicNavbar;
                this.pageCopy.CaptureGateEnabled = !!this.pageCopy.CaptureGateEnabled;
                this.pageCopy.HasPageAccessPassword = !!this.pageCopy.HasPageAccessPassword;
                this.pageCopy.PageAccessPassword = '';
                this.hadPageAccessPassword = !!this.sidebarParams.HadPageAccessPassword;
                this.pageAccessPassword = this.sidebarParams.GetPageAccessPassword();

                if(!this.pageCopy.Headlines) {
                    this.pageCopy.Headlines = '';
                }

                if(!this.pageCopy.ContactInfo.Bio) {
                    this.pageCopy.ContactInfo.Bio = '';
                }

                if(!this.pageCopy.PrimaryMedia.Uri) {
                    this.pageCopy.PrimaryMedia.Uri = '';
                }
            }
        },

        'pageCopy': {
            deep: true,
            handler() {
                window.$bus.$emit('PageDetailsEdited', 
                    this.sidebarParams.EntityTypeCode,
                    this.sidebarParams.EntityCode,
                    this.pageCopy);
            }
        },
        'pageAccessPassword': {
            handler(value) {
                this.sidebarParams.SetPageAccessPassword(value);
            }
        },
    },

    beforeUnmount() {
    },

    mounted() {
    },

    methods: {
        async copyPublicPageLink() {
            await navigator.clipboard.writeText(this.publicPageUrl);
        },
        closePage() {
            window.$bus.$emit('page-editor-closed');
            this.$emit('closerequest');
        },
    },

    data() {
        return {
            pageCopy: null,
            pageAccessPassword: '',
            hadPageAccessPassword: false,
        }
    },
}
</script>
